import { applyPanel } from "./UiPanel";
import { PARCHMENT, LAYERS } from "./theme";
import { playUiClick } from "../audio/sfx";
import { isMobile, onMobileChange } from "./platform";
let dom = null;
let buildHandler = null;
// Icons replace text labels on both platforms; the German label survives as a title tooltip
// for desktop hover and screen readers.
function makeChip(icon, label, container) {
    const chip = document.createElement("div");
    chip.style.cssText = "display: flex; align-items: center; gap: 4px;";
    chip.title = label;
    const iconEl = document.createElement("span");
    iconEl.style.cssText = "font-size: 14px; line-height: 1;";
    iconEl.textContent = icon;
    const count = document.createElement("span");
    count.style.cssText = `
    font-size: 12px;
    font-weight: 700;
    color: ${PARCHMENT.accent};
    min-width: 16px;
  `;
    count.textContent = "0";
    chip.append(iconEl, count);
    container.appendChild(chip);
    return count;
}
// Desktop keeps the original horizontal chip row; mobile stacks resources vertically along
// the panel's top-right corner (still anchored top:12/right:12 — see getDom) so it stays out
// of the way of the map underneath on narrow screens.
function applyLayout() {
    if (!dom)
        return;
    const mobile = isMobile();
    dom.panel.style.flexDirection = mobile ? "column" : "row";
    dom.panel.style.alignItems = mobile ? "flex-end" : "center";
    dom.resourcesRow.style.flexDirection = mobile ? "column" : "row";
    dom.resourcesRow.style.alignItems = mobile ? "flex-end" : "center";
}
function getDom() {
    if (dom)
        return dom;
    const panel = document.createElement("div");
    panel.style.cssText = `
    position: fixed;
    z-index: ${LAYERS.resourceHud};
    top: 12px;
    right: 12px;
    font-family: ui-sans-serif, system-ui, sans-serif;
    box-shadow: 0 6px 20px rgba(0,0,0,0.35);
    display: none;
    padding: 7px 12px;
    gap: 10px;
    user-select: none;
  `;
    applyPanel(panel, "beige");
    const resourcesRow = document.createElement("div");
    resourcesRow.style.cssText = "display: flex; gap: 10px;";
    const woodCount = makeChip("🪵", "Holz", resourcesRow);
    const steelCount = makeChip("🔩", "Stahl", resourcesRow);
    const manpowerCount = makeChip("👷", "Arbeitskraft", resourcesRow);
    const buildBtn = document.createElement("button");
    buildBtn.textContent = "Bauen";
    buildBtn.style.cssText = `
    padding: 3px 10px;
    font-size: 11px;
    font-weight: 600;
    border-radius: 4px;
    border: 1px solid ${PARCHMENT.highlightBorder};
    background: ${PARCHMENT.highlightBg};
    color: ${PARCHMENT.text};
    display: none;
  `;
    // The whole panel is clickable when building is available — not just the "Bauen" chip — so
    // the resource counts themselves are a valid place to click too. buildBtn stays a real
    // <button> for the visual affordance and keyboard access; its own click bubbles up to here,
    // so it doesn't need (and shouldn't have) a second listener of its own.
    panel.addEventListener("click", () => {
        if (buildHandler) {
            playUiClick();
            buildHandler();
        }
    });
    panel.append(resourcesRow, buildBtn);
    document.body.appendChild(panel);
    dom = { panel, resourcesRow, woodCount, steelCount, manpowerCount, buildBtn };
    applyLayout();
    onMobileChange(applyLayout);
    return dom;
}
export function updateResourceHud(resources, currentUserId) {
    if (!currentUserId) {
        if (dom)
            dom.panel.style.display = "none";
        return;
    }
    const d = getDom();
    d.panel.style.display = "flex";
    const own = resources.find((r) => r.userId === currentUserId);
    d.woodCount.textContent = String(own?.wood ?? 0);
    d.steelCount.textContent = String(own?.steel ?? 0);
    d.manpowerCount.textContent = String(own?.manpower ?? 0);
}
export function setBuildHandler(cb) {
    buildHandler = cb;
    const d = getDom();
    d.buildBtn.style.display = cb ? "" : "none";
    // The panel contains a real nested <button> ("Bauen"), so it can't become one itself —
    // .clickable is what the global button-cursor CSS rule keys off for this non-button case.
    d.panel.classList.toggle("clickable", !!cb);
}
export function hideResourceHud() {
    if (dom)
        dom.panel.style.display = "none";
}
